/**
 * Verifica se string é vazia ou com espaços em branco
 *
 * @param {string} str
 */
export const isBlank = (str) => {
  return !str || /^\s*$/.test(str);
};
